import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Card } from 'primereact/card';
import { Button } from 'primereact/button';

import Sonaca from './dialogs/sonaca.js';
import Safran from './dialogs/safran.js';
import Upsilon from './dialogs/upsilon.js';
import Addvance from './dialogs/addvance.js';
import ColombieCadet from './dialogs/colombiecadet.js';

import addvanceLogo from "../../../../../assets/addvanceLogo.png";
import colombieCadetLogo from "../../../../../assets/colombieCadetLogo.jpg";
import safranLogo from "../../../../../assets/safranlogo.png";
import upsilonLogo from "../../../../../assets/upsilon-black.png";

import './professional.css'

export default function Professional() {

    const { t } = useTranslation();

    const [sonacaVisible, setSonacaVisible] = useState(false);
    const [safranVisible, setSafranVisible] = useState(false);
    const [upsilonVisible, setUpsilonVisible] = useState(false);
    const [addvanceVisible, setAddvanceVisible] = useState(false);
    const [colombieCadetVisible, setColombieCadetVisible] = useState(false);

    return (
        <>
            <div className="back-container-black pt-1 relative pb-6">
                <h2 className="text-center titles text-300">{t("professional")}</h2>
                
                <div className="flex justify-content-center w-full">
                    <div className="grid xl:w-8 w-10">
                        <div className="md:col-6 col-12">
                            <Card className="professional-card border-green-300 sonacaCard cursor-pointer" onClick={() => setSonacaVisible(true)}>
                                <div className="flex justify-content-between flex-column mb-3 h-full">
                                    <h4 className="mt-0 text-green-700 md:-mt-4 -mt-3 md:text-right">{t("sonacaDate")}</h4>
                                    <div className="w-full flex justify-content-center bottom-0">
                                        <Button label="Details" className="mt-3 cardButton" onClick={() => setSonacaVisible(true)} outlined/>
                                    </div>
                                </div>
                            </Card>
                        </div>
                        <div className="md:col-6 col-12">
                            <Card className="professional-card border-blue-500 safranCard cursor-pointer" onClick={() => setSafranVisible(true)}>
                                <div className="flex flex-column h-full">

                                    <h4 className="mt-0 mb-0 text-blue-700 md:-mt-4 -mt-3">{t("safranDate")}</h4>

                                    <div className="w-full flex justify-content-center -mt-2">
                                        <img src={safranLogo} alt="Safran logo" width="150" height="30"/>
                                    </div>

                                    <div className="flex-1"></div>

                                    <div className="w-full flex justify-content-center">
                                        <Button label="Details" className="cardButton" onClick={() => setSafranVisible(true)} outlined />
                                    </div>
                                </div>
                            </Card>
                        </div>
                        <div className="col-12">
                            <Card className="professional-card border-pink-300 upsilonCard cursor-pointer" onClick={() => setUpsilonVisible(true)}>
                                <div className="flex flex-column h-full">

                                    <h4 className="mt-0 mb-0 text-pink-500 md:-mt-4 -mt-3">{t("upsilonDate")}</h4>

                                    <div className="w-full flex justify-content-end -mt-3">
                                        <img src={upsilonLogo} alt="Upsilon logo" width="160" height="80"/>
                                    </div>

                                    <div className="flex-1"></div>

                                    <div className="w-full flex justify-content-center">
                                        <Button label="Details" className="cardButton" onClick={() => setUpsilonVisible(true)} outlined />
                                    </div>
                                </div>
                            </Card>
                        </div>
                        <div className="md:col-6 col-12">
                            <Card className="professional-card border-green-700 addvanceCard cursor-pointer" onClick={() => setAddvanceVisible(true)}>
                                <div className="flex flex-column h-full">

                                    <h4 className="mt-0 mb-0 text-green-700 md:text-right md:-mt-4 -mt-3">{t("addvanceDate")}</h4>

                                    <div className="w-full flex justify-content-center md:-mt-3">
                                        <img src={addvanceLogo} alt="Addvance logo" width="110" height="60"/>
                                    </div>

                                    <div className="flex-1"></div>

                                    <div className="w-full flex justify-content-center">
                                        <Button label="Details" className="cardButton" onClick={() => setAddvanceVisible(true)} outlined />
                                    </div>
                                </div>
                            </Card>
                        </div>
                        <div className="md:col-6 col-12">
                            <Card className="professional-card colombieCadetCard border-800 cursor-pointer" onClick={() => setColombieCadetVisible(true)}>
                                <div className="flex flex-column h-full">

                                    <h4 className="mt-0 mb-0 text-800 text-left md:-mt-4 -mt-3">{t("colombieCadetDate")}</h4>

                                    <div className="w-full flex justify-content-center md:-mt-3">
                                        <img src={colombieCadetLogo} alt="Colombie Cadet logo" width="140" height="60"/>
                                    </div>

                                    <div className="flex-1"></div>

                                    <div className="w-full flex justify-content-center">
                                        <Button label="Details" className="cardButton" onClick={() => setColombieCadetVisible(true)} outlined />
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
            <Sonaca visible={sonacaVisible} setVisible={setSonacaVisible}/>
            <Safran visible={safranVisible} setVisible={setSafranVisible}/>
            <Upsilon visible={upsilonVisible} setVisible={setUpsilonVisible}/>
            <Addvance visible={addvanceVisible} setVisible={setAddvanceVisible}/>
            <ColombieCadet visible={colombieCadetVisible} setVisible={setColombieCadetVisible}/>
        </>
    )

}